














































// @ts-nocheck
import { Component, Vue, Watch } from 'vue-property-decorator'
import { DataStore, SortDirection, Hub } from 'aws-amplify'
import AddDialog from '@/components/dialogs/Add.vue'
import ConfirmDialog from '@/components/dialogs/Confirm.vue'
import Draggable from 'vuedraggable'
import { GenerateLocaleDict } from '@/lib/Locale'
import { query as tenant } from '@/store/tenant'
import { mutateSnackbar } from '@/store/snackbar'
import { Page } from '../models/index'
import { HubEvents } from '@/amplify'

@Component<PagesView>({
  components: {
    Draggable,
    AddDialog,
    ConfirmDialog
  },
  // @ts-ignore
  metaInfo() {
    return {
      title: this.$t('pages.title')
    }
  },
  apollo: {
    tenant
  }
})
export default class PagesView extends Vue {
  pages = []
  pagesSubscription = null
  isSaving: boolean = false
  isLoading = true

  @Watch('tenant')
  async recreate() {
    this.subscribeToPages();
  }

  created() {
    this.subscribeToPages();
  }

  subscribeToPages() {
    if (!this.tenant) return;
    this.pagesSubscription?.unsubscribe()
    this.pagesSubscription = DataStore.observeQuery(
      Page,
      p => p.tenant.eq(this.tenant.id),
      {
        sort: s => s.sortPosition(SortDirection.ASCENDING)
      }
    ).subscribe(({ items }) => {
      this.pages = items
      setTimeout(() => {
        this.isLoading = false
      }, 250)
    })
  }
  
  destroyed() {
    this.pagesSubscription?.unsubscribe()
  }

  async addPage(title: string) {
    try {
      await DataStore.save(
        new Page({
          title: GenerateLocaleDict({ de: title }),
          sortPosition: this.pages.length,
          content: GenerateLocaleDict(),
          tenant: this.tenant?.id
        })
      )
      mutateSnackbar(
        { text: String(`Seite erstellt.`), color: `success` },
        this.$apollo
      )
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
  }

  async deletePage(id: string) {
    try {
      await DataStore.delete(Page, item => item.id.eq(id))
      mutateSnackbar(
        { text: String(`Seite gelöscht.`), color: `success` },
        this.$apollo
      )
    } catch (err) {
      mutateSnackbar({ text: err, color: `error`, timeout: 5000 }, this.$apollo)
    }
  }

  async saveOrder() {
    if (!this.pages || this.pages.length <= 0) return
    this.isSaving = true
    this.pagesSubscription.unsubscribe()
    for (const [index, page] of this.pages.entries()) {
      await DataStore.save(
        Page.copyOf(page, updated => {
          updated.sortPosition = index
        })
      )
    }
    Hub.dispatch('ListEdit', {
      event: HubEvents.orderSave,
      data: {
        model: 'Page',
      }
    })

    setTimeout(() => {
      this.subscribeToPages()
      this.isSaving = false
    }, 250)
  }
}
